import { Box, Grid, Typography, useTheme } from '@material-ui/core';
import { FC, Fragment } from 'react';
import { InfoItemProps } from '../InfoItem';
import { disableStyle } from 'shared/utils/disableStyling';
import { GridVariantItemContainer } from './GridVariantItem.styles';
import { Progress } from 'components/MyInfo/Progress/Progress';
import { ActionButtons } from '../ActionButtons/ActionButtons';
import { COLORS } from 'shared/constants/COLORS';
import { Skeleton } from '@material-ui/lab';
import { CustomTypography } from 'shared/elements/CustomTypography';

const GridVariantItem: FC<InfoItemProps> = ({
  info,
  attached_media,
  onEdit,
  onDelete,
  onView,
  isSaving = false,
  isEditing = false,
  isDeleting = false,
}) => {
  const commonStyle = disableStyle(isSaving, isEditing, isDeleting);
  const theme = useTheme();
  return (
    <div>
      <CustomTypography fontSize={14} style={{ textAlign: 'end', marginRight: 8 }}>
        {attached_media?.slice(0, 5)?.length} / 5
      </CustomTypography>
      <GridVariantItemContainer style={{ cursor: 'pointer', ...commonStyle }} onClick={onView}>
        <Box style={{ display: 'flex', gap: 10, width: '100%' }}>
          {Array(5)
            .fill('')
            .map((_, index) => (
              <Box key={index} style={{ aspectRatio: '16/9', width: '100%', height: '100%' }}>
                {attached_media && attached_media[index] ? (
                  <img
                    style={{ width: '100%', height: '100%', borderRadius: 4 }}
                    src={
                      attached_media[index]?.attributes?.modified_attachment_url ||
                      attached_media[index]?.attributes?.cropped_attachment_url ||
                      attached_media[index]?.attributes?.attachment_url ||
                      ''
                    }
                    alt="media"
                  />
                ) : (
                  <Skeleton
                    variant="rect"
                    width={'100%'}
                    height={'100%'}
                    animation={false}
                    style={{ borderRadius: 4 }}
                  />
                )}
              </Box>
            ))}
        </Box>

        <Box style={{ width: '100%' }}>
          <Grid container spacing={1}>
            {info.map((data, index) => (
              <Grid item xs={6} style={{ textAlign: index % 2 !== 0 ? 'end' : 'start', width: '100%' }} key={data.name}>
                <Typography
                  style={{
                    width: '100%',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    fontSize: 14,
                    fontWeight: 600,
                  }}
                  color="initial"
                >
                  {data?.name ? `${data?.name}: ` : null}
                  <Typography
                    style={{ fontSize: 14, color: theme.palette.type === 'dark' ? COLORS.WHITE : COLORS.BLACK }}
                    component="span"
                  >
                    {data.details}
                  </Typography>
                </Typography>
              </Grid>
            ))}
            <Grid
              item
              xs={info?.length % 2 !== 0 ? 6 : 12}
              style={{ width: '100%', display: 'flex', justifyContent: 'end' }}
            >
              {isSaving || isEditing || isDeleting ? (
                <Progress isDeleting={isDeleting} />
              ) : (
                <ActionButtons onDelete={onDelete} onEdit={onEdit} isDisabled={isSaving || isEditing || isDeleting} />
              )}
            </Grid>
          </Grid>
        </Box>
      </GridVariantItemContainer>
    </div>
  );
};

export default GridVariantItem;
